import * as ACTION_TYPES from "../actions/action-types";

const initialState = {
  views: [],
  userFavViews: []
};

/**
 * setting states according to the type of actions
 * @param {*} state
 * @param {*} action
 * @returns {state}
 */

const userViews = (state = initialState, action) => {
  const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.SETVIEWS:
          return {
            ...state,
            views: payload
          }
        case ACTION_TYPES.USERFAV:
          return{
            ...state,
            userFavViews: payload
          }
          default:
      return state;
    }
};

export default userViews;